import Popup from './popup';

export default function Loading(): JSX.Element {
  return <Popup>Please wait a sec, we are loading...</Popup>;
}
